import { cn } from "#Utils/cn"

const DescriptionList = ({ children, noBorder, className }) => {
  const classes = ["c-description-list", className].filter(Boolean)
  if (noBorder) {
    classes.push("border-0")
  }

  return <dl className={classes.filter((f) => f).join(" ")}>{children}</dl>
}

DescriptionList.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  className: PropTypes.string,
}

const DescriptionListTerm = ({ children, className }) => (
  <dt className={cn("c-description-list__label", className)}>{children}</dt>
)

DescriptionListTerm.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

const DescriptionListDescription = ({ children, className }) => (
  <dd className={cn("c-description-list__value", className)}> {children}</dd>
)

DescriptionListDescription.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

DescriptionList.Term = DescriptionListTerm
DescriptionList.Description = DescriptionListDescription
DescriptionList.Label = DescriptionListTerm
DescriptionList.Value = DescriptionListDescription

export default DescriptionList
